"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var copyData = function (data) {
    return data && typeof data !== 'string' ? JSON.parse(JSON.stringify(data)) : data;
};
var arrayToObj = function (mockRes) {
    return Array.isArray(mockRes) ? { status: mockRes[0], data: mockRes[1], headers: mockRes[2] } : mockRes;
};
exports.default = (function (mockRes, config) {
    var _a = arrayToObj(mockRes), status = _a.status, data = _a.data, headers = _a.headers;
    return {
        status: status,
        statusText: "" + status,
        data: copyData(data),
        headers: headers,
        config: config
    };
});
//# sourceMappingURL=makeResponse.js.map